import React from 'react';
import { css } from 'glamor';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../Redux/Store/store';
import { AddAnimationPayloadInterface, ChangeKeyControlsAction, PlayStopAction } from '../../../../Redux/Actions/Animator/animation.list.action';
import { find, propEq } from 'ramda';

const FramesKeyControlInput = css({
    width: '40px',
    border: 'none',
    borderRadius: '3px',
    textAlign: 'right'
});
const disable = css({
    opacity: 0.2
});

const FramesKeyControls = () => {

    const animation_list = useSelector((state: RootState) => state.AnimationList);
    const actual_animation: AddAnimationPayloadInterface = find(propEq('id', animation_list.actual_animation), animation_list.animations);

    const dispatch = useDispatch();

    const change_key_controls = (key_controls: any) => {
        dispatch(PlayStopAction({ id: '0', play: false }));
        dispatch(ChangeKeyControlsAction({
            id: animation_list.actual_animation,
            key_controls
        }));
    }
    return (
        <div className="mt-2">
            <h4 className="text-color-primary">Key Controls</h4>
            {
                (actual_animation !== undefined) &&
                <div className={`ml-2 mt-2 ${(actual_animation === undefined) && disable}`}>
                    <div className={`d-flex align-items-center justify-content-between mb-1 hiden_input_spin`}>
                        Repeat
                    <input type="number" className={`${FramesKeyControlInput}`} value={actual_animation.key_controls.repeat} onChange={(e) => {
                            change_key_controls({
                                ...actual_animation.key_controls,
                                repeat: (Number(e.target.value) > 99) ? 100 : (Number(e.target.value) < -2) ? -1 : Number(e.target.value)
                            });
                        }} />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-1 hiden_input_spin">
                        Frame Rate
                    <input type="number" className={`${FramesKeyControlInput}`} value={actual_animation.key_controls.frame_rate} min={1} max={100}
                            onKeyDown={(e) => {
                                if (e.keyCode === 38 || e.keyCode === 40) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                change_key_controls({
                                    ...actual_animation.key_controls,
                                    frame_rate: (Number(e.target.value) > 199) ? 200 : (Number(e.target.value) < 1) ? 1 : Number(e.target.value)
                                });
                            }} />
                    </div>
                    {(false) &&
                        <div className="d-flex align-items-center justify-content-between mb-1">
                            YoYo
                        <input type="checkbox" checked={actual_animation.key_controls.yoyo} onChange={(e) => {

                                change_key_controls({
                                    ...actual_animation.key_controls,
                                    yoyo: e.target.value
                                });
                            }} />
                        </div>
                    }
                </div>
            }


        </div>
    );
}

export default FramesKeyControls;